import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLazyGetLivestreamPlayerDetailsQuery } from "../../../store/api/academyApi";
import { Link } from "react-router-dom";
import { BackButtonIcon } from "../../../icons/academy-icons";
import ReactPlayer from "react-player";
const LivestreamPlayerComponent = () => {
  const [videoData, setVideoData] = useState<any>(null);
  const [getLivestreamPlayerDetails] = useLazyGetLivestreamPlayerDetailsQuery();
  const { livestream_id } = useParams();
  const is_zoom_play_url = videoData?.is_zoom_play_url;

  useEffect(() => {
    const getVideoData = async () => {
      try {
        const response = await getLivestreamPlayerDetails({
          livestreamId: livestream_id,
        })?.unwrap();
        setVideoData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    getVideoData();
  }, []);

  return (
    <>
      {videoData && videoData.zoom_link ? (
        <div className="relative">
          <div className="flex items-center h-fit gap-2 mb-4">
            <Link to="/academy/livestream">
              <BackButtonIcon width={20} height={16} />
            </Link>
            <h1 className="text-[36px] font-bold">{videoData.title}</h1>
          </div>
          {is_zoom_play_url ? (
            <iframe
              src={videoData.zoom_link}
              width="100%"
              height="620"
              style={{
                objectFit: "cover",
                clipPath: "inset(40px 0 0 0)",
                backgroundColor: "white",
              }}
              allow="fullscreen"
              className="absolute top-6"
            />
          ) : (
            <ReactPlayer
              url={videoData.zoom_link}
              autoPlay={true}
              controls={true}
              width="1200"
              height="auto"
            />
          )}
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <h1 className="text-[36px] font-bold">No video data found</h1>
        </div>
      )}
    </>
  );
};

export default LivestreamPlayerComponent;
